import { PropsWithChildren } from "react";
import { Helmet } from "react-helmet-async";

export default function RouteWrapper({ title, children, ...props }: PropsWithChildren<{ title: string }>) {
    return (
        <>
            <Helmet prioritizeSeoTags>
                <title>Moto4Rent | {title}</title>
            </Helmet>

            {children}
        </>
    )
}